import api from './api';
import { LoginCredentials, LoginResponse, User } from '../types';

export const authService = {
  async login(credentials: LoginCredentials): Promise<LoginResponse> {
    const response = await api.post<LoginResponse>('/auth/login', credentials);
    return response.data;
  },

  async getCurrentUser(): Promise<User> {
    const response = await api.get<User>('/auth/me');
    return response.data;
  },

  async getAllUsers(): Promise<User[]> {
    const response = await api.get<User[]>('/auth/users');
    return response.data;
  },

  async createUser(data: { username: string; password: string; role: string }): Promise<User> {
    const response = await api.post<User>('/auth/users', data);
    return response.data;
  },

  async updateUserRole(id: number, role: string): Promise<User> {
    const response = await api.put<User>(`/auth/users/${id}/role`, { role });
    return response.data;
  },

  async updateUserPassword(id: number, password: string): Promise<void> {
    await api.put(`/auth/users/${id}/password`, { password });
  },

  async deleteUser(id: number): Promise<void> {
    await api.delete(`/auth/users/${id}`);
  },
};
